'use client'

import type { MouseEvent, ReactNode } from 'react'

import { Anchor } from '@/components/client/seo/anchor'

interface SectionScrollLinkProps {
  sectionId: string
  className?: string
  children: ReactNode
}

// Scrolls to an in-page section the same way the article TOC does: account for the
// sticky-header offset, no smooth animation (matches the old site), and no URL hash
// change. Used by the quick-verdict picks so clicking a product name jumps to its
// listicle section like a TOC item. Falls back to the native anchor jump if the
// target isn't found (SSR / hydration edge).
export const SectionScrollLink = ({ sectionId, className, children }: SectionScrollLinkProps) => {
  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // The Visual Editor can claim this click to select the product in place.
    if (e.defaultPrevented) return
    const target = document.getElementById(sectionId)
    if (!target) return
    e.preventDefault()
    // Resolve content-visibility layout before measuring the target's position.
    target.scrollIntoView({ block: 'start', behavior: 'instant' })
    const top = target.getBoundingClientRect().top + window.scrollY - 80
    window.scrollTo({ top, behavior: 'auto' })
  }
  return (
    <Anchor href={`#${sectionId}`} onClick={onClick} className={className} data-tracking="ignore">
      {children}
    </Anchor>
  )
}
